import { render, staticRenderFns } from "./TrainingCode.vue?vue&type=template&id=0641e038&scoped=true"
import script from "./TrainingCode.vue?vue&type=script&lang=js"
export * from "./TrainingCode.vue?vue&type=script&lang=js"
import style0 from "./TrainingCode.vue?vue&type=style&index=0&id=0641e038&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0641e038",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3029718028/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0641e038')) {
      api.createRecord('0641e038', component.options)
    } else {
      api.reload('0641e038', component.options)
    }
    module.hot.accept("./TrainingCode.vue?vue&type=template&id=0641e038&scoped=true", function () {
      api.rerender('0641e038', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/lifehikes/training/components/TrainingCode.vue"
export default component.exports